module.exports = __webpack_public_path__ + "static/media/Co_Name.b8da9c55.svg";